import {
  ColorValue,
  BorderValue,
  FontValue,
  NumericValue,
} from '../../types/metadata/stylesDefinition';
import { parseToRgba } from 'color2k';
import { ApplyTheme } from './types';
import { isCssVariable } from './apply-theme-variables';

export const formatColor = (
  { preset, opacity }: ColorValue,
  applyTheme: ApplyTheme,
) => {
  if (typeof opacity === 'number') {
    if (isCssVariable(preset)) {
      const themedValue = applyTheme(preset);
      try {
        if (themedValue !== preset && !isCssVariable(themedValue)) {
          const [r, g, b] = parseToRgba(themedValue);
          return `rgba(${r}, ${g}, ${b}, ${opacity})`;
        }
        return `rgba(${preset}, ${opacity})`;
      } catch (error) {
        console.log('error formatting color', error);
        return themedValue;
      }
    } else {
      try {
        const [r, g, b] = parseToRgba(preset);
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
      } catch (error) {
        console.log('error formatting color', error);
        return preset;
      }
    }
  }
  return applyTheme(preset);
};

export const formatBorder = (value: BorderValue, applyTheme: ApplyTheme) => {
  const parts = [];
  if ('width' in value && value.width) {
    parts.push(formatNumeric({ value: value.width, unit: 'px' }, applyTheme));
  }
  if ('style' in value && value.style) {
    parts.push(applyTheme(value.style));
  }
  if ('color' in value && value.color) {
    parts.push(formatColor(value.color, applyTheme));
  }

  return parts.length > 1 ? parts.join(' ') : parts[0];
};

export const formatFont = (value: FontValue, applyTheme: ApplyTheme) => {
  return applyTheme(
    value.size
      ? `${formatNumeric({ value: value.size, unit: 'px' }, applyTheme)} ${
          value.preset
        }`
      : value.preset,
  );
};

export const formatNumeric = (
  { value, unit }: { value: NumericValue; unit?: string },
  applyTheme: ApplyTheme,
): string =>
  applyTheme(typeof value === 'number' ? `${value}${unit ?? ''}` : value);

export const formatGeneric = (value: any, applyTheme: ApplyTheme) =>
  applyTheme(String(value));
